import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { ProvisionDomain } from 'src/app/models';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DomainManageService {

  constructor(private http: HttpClient) { }

  public getProvisionData(deploymentId: number): Observable<ProvisionDomain> {
    return this.http.get<ProvisionDomain>(`${environment.apiUrl}deployments/${deploymentId}/provisions`);
  }
  public putProvisionData(deploymentId: number, provisionId: number, provision: any): Observable<any> {
    return this.http.put<any>(`${environment.apiUrl}deployments/${deploymentId}/provision/${provisionId}`, provision);
  }
}
